import React from 'react';

import LegalPolicyPage from './LegalPolicyPage';

interface RefundCancellationPageProps {
  onNavigate: (view: string) => void;
}

const RefundCancellationPage: React.FC<RefundCancellationPageProps> = ({ onNavigate }) => (
  <LegalPolicyPage policyId="refund" onNavigate={onNavigate} />
);

export default RefundCancellationPage;
